module.exports = __webpack_public_path__ + "img/gmail.d348f73b.svg";